export enum ContainerStatus {
    READY_FOR_PICKUP = "ready_for_pickup",
    MAINTENANCE = "maintenance",
    AWAITING_PICKUP = "awaiting_pickup",
    EMPTY = "empty",
    PENDING = "pending",
    INACTIVE = "inactive",
  }